import {connect} from "react-redux";
import React, {useRef, useState} from "react";
import {Button, Form, Card} from "react-bootstrap";
import {ConfigurationsType} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import {getSyncSearchFormValuesByState} from "../../../helpers/configurationHelper";
import { updatePathCoordinatesDispatchAction} from "../../../state/geoMap/dispatchActions";
import translations from "../../../translations";
import {parseKMLFile, parseShapeFile} from "../../../helpers/parserHelper";
import {errorToastNotification, successToastNotification} from "../../../helpers/toastNotificationHelper";
import {getCoordinatesFromGeoJSON} from "../../../helpers/geoJSONHelper";
import {AppParametersType} from "../../../types/app";

interface PropsType {
    configurations: ConfigurationsType,
    selectedArea: ShapeType,
    values: any,
    updatePathCoordinatesActionHandler: any,
    handleCloseModal: any,
    appParameters: AppParametersType,
}

const KMLAOIHelper = (props: PropsType) => {
  const {
    configurations,
    selectedArea,
    values,
    updatePathCoordinatesActionHandler,
    handleCloseModal,
    appParameters
  } = props;
  const inputEl: any = useRef(null);
  const [isKml, setIsKml] = useState(true)
  const [fileName, setFileName] = useState("")
  const [pathString, setPathString]: any = useState(null)
  const [fileLength, setFileLength]: any = useState(null)

  const drawArea = () => {
    if (pathString && fileLength) {
      updatePathCoordinatesActionHandler(configurations, appParameters, selectedArea, values, pathString, appParameters.language)
        .then(() => {
          // eslint-disable-next-line no-template-curly-in-string
          successToastNotification(isKml ? `${translations("kmlImportedPathImporter", appParameters.language).replace("${result.polygons.length}", fileLength)}` : `${translations("shapeImportedPathImporter", appParameters.language).replace("${geoJson.features.length}", fileLength)}`);
          handleCloseModal()
          setPathString(null)
          setFileLength(null)
        })
    }
  }

  return (
    <>
      <div className="row path-importer-container">
        <Card.Subtitle className="mb-3 col-12">
          {" "}
          {translations("importKmlShapeLabel", appParameters.language)}
        </Card.Subtitle>
        <div className="col-12">
          <Button onClick={(event) => {
            event.preventDefault();
            // event.stopPropagation();
            if (inputEl && inputEl.current) {
              console.log(inputEl.current)
              inputEl.current.click()
            }
          }}
          >
            {translations("chooseFile", appParameters.language)}
          </Button>
          <Form.Label className="ml-4">
            {fileName}
          </Form.Label>
          <input
            ref={inputEl}
            type="file"
            accept=".kml, .zip"
            className="d-none"
            value=""
            onChange={(event) => {
              if (event && event.target && event.target.files && event.target.files[0]) {
                const file = event.target.files[0];
                setFileName(event.target.files[0].name)
                if (file.name.match(/\.kml$/)) {
                  setIsKml(true)
                  parseKMLFile(file, (result) => {
                    if (result) {
                      if (result.polygons && result.polygons.length > 0) {
                        // take the first
                        const coords = result.polygons[0].map((p) => [p.lng, p.lat]);
                        setPathString(coords.map((p) => `${p[0]} - ${p[1]}`).join(", "))
                        setFileLength(result.polygons.length)
                      } else {
                        errorToastNotification(translations("errorNotAoiKMLPathImporter", appParameters.language));
                      }
                    } else {
                      errorToastNotification(translations("errorParseKmlPathImporter", appParameters.language));
                    }
                  });
                } else if (file.name.match(/\.zip$/)) {
                  setIsKml(false)
                  parseShapeFile(file, (geoJson) => {
                    if (geoJson) {
                      if (geoJson.features && geoJson.features.length > 0) {
                        // take the first
                        const coords = getCoordinatesFromGeoJSON(geoJson.features[0]);
                        setPathString(coords.map((p) => `${p[0]} - ${p[1]}`).join(", "))
                        setFileLength(geoJson.features.length)
                      } else {
                        errorToastNotification(translations("errorNotAoiShapePathImporter", appParameters.language));
                      }
                    } else {
                      errorToastNotification(translations("errorParseShapePathImporter", appParameters.language));
                    }
                  })
                } else {
                  errorToastNotification(translations("aoiNotSupportedPathImporter", appParameters.language));
                }
              }
            }}
          />
        </div>
      </div>
      <div className="row mx-0 mt-4">
        <div className="m-0 px-0 d-flex col-12">
          <p>{translations("circleCenterToolDisclaimer", appParameters.language)}</p>
        </div>
      </div>
      <Button
        onClick={() => {
          drawArea()
        }}
        className="float-right"
      >
        <span>{translations("done", appParameters.language)}</span>
      </Button>
    </>
  );
};

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  values: getSyncSearchFormValuesByState(state),
  appParameters: state.application.appParameters,
});

const mapDispatchToProps = (dispatch) => ({
  updatePathCoordinatesActionHandler: (configurations, appParameters, selectedArea, values, pathString, language) => dispatch(updatePathCoordinatesDispatchAction(configurations, appParameters, selectedArea, values, pathString, appParameters))
});

export default connect(mapStateToProps, mapDispatchToProps)(KMLAOIHelper);
